import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'kt-custom-header',
  templateUrl: './custom-header.component.html',
  styleUrls: ['./custom-header.component.scss']
})
export class CustomHeaderComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
